import React from "react";
import { TooltipTheOneWrapper } from "./TooltipTheOne";
import { Icon, iconName, IconSize } from "./icons/Icons";

type ToggletipTheOneProps = {
    icon?:iconName,
    iconColor?:string,
    iconSize?:IconSize,
    display?: 'inline' | 'inline-flex' | 'block',
    horizontalAlignment?: 'left' | 'right',
    verticalAlignment?: 'top' | 'bottom'
    children: React.ReactNode
};
export function ToggletipTheOne(props: ToggletipTheOneProps): JSX.Element
{
    return (

        <TooltipTheOneWrapper 
            tooltipContent={props.children} 
            horizontalAlignment={props.horizontalAlignment} 
            verticalAlignment={props.verticalAlignment} 
            display={props.display ?? 'inline-flex'}>

            <Icon name={props.icon ?? "help"} color={props.iconColor} size={props.iconSize} />
            
        </TooltipTheOneWrapper>
    );
}